import React, { useEffect, useState } from 'react';
import { Typography, FormLabel, TextField, Button, Box, Grid } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import plusIcon from '../img/PlusIcon.svg';

const ContextoEspecíficoEstudiante = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const [agregarInfo, setAgregarInfo] = useState(false);
    const [nuevaInfo, setNuevaInfo] = useState('');
    const [infoEstudiante, setInfoEstudiante] = useState(promptData.condiciones_contexto || []);
    const { setProyecto } = useProyecto();
    

    useEffect(() => {
        setInfoEstudiante(promptData.condiciones_contexto || []);
    }, [promptData]);

    const handleGuardarInfo = () => {
        if (nuevaInfo.trim() !== '') {
            const nuevaInfoEstudiante = [...infoEstudiante, nuevaInfo];
            setInfoEstudiante(nuevaInfoEstudiante);
            setNuevaInfo('');
            setAgregarInfo(false);
            setPromptData((prevData) => ({
                ...prevData,
                condiciones_contexto: nuevaInfoEstudiante
            }));
        }
    };

    const handleAgregarInfo = () => {
        setAgregarInfo(true);
    };

    const handleEliminarInfo = (index) => {
        // Obtiene la información específica a eliminar
        const infoAEliminar = infoEstudiante[index];
        const nuevasInfo =  infoEstudiante.filter((_, i) => i !== index);
        // Actualiza el estado de la información del estudiante, eliminando la información seleccionada
        setInfoEstudiante(nuevasInfo);
        setPromptData((prevData) => ({
            ...prevData,
            condiciones_contexto: nuevasInfo,
        }));
        // Actualiza el estado del proyecto, eliminando la información específica seleccionada
        setProyecto((prevProyecto) => ({
            ...prevProyecto,
            contexto_estudiante: prevProyecto.contexto_estudiante
                ? prevProyecto.contexto_estudiante.filter(info => info !== infoAEliminar)
                : []
        }));
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={3}>
            <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Contexto Específico del Estudiante (opcional)
                </Typography>
            </Box>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>
                Proporciona información adicional relevante sobre el estudiante (dificultades, logros, circunstancias personales, etc.).

            </FormLabel>
            {agregarInfo ? (
                <Grid container spacing={2} mt={3} alignItems="center">
                    <Grid item xs={12} sm={8}>
                        <TextField
                            label="Nuevo contexto"
                            variant="outlined"
                            fullWidth
                            value={nuevaInfo}
                            onChange={(e) => setNuevaInfo(e.target.value)}
                            sx={{ fontFamily: 'montserrat', mr: 2, mb: 2 }}
                            InputProps={{
                                sx: {
                                    borderRadius: 2,
                                    fontFamily: 'montserrat',
                                    fontSize: '0.75rem',
                                    color: '#336B87',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button
                            sx={{
                                backgroundColor: '#336B87',
                                '&:hover': { backgroundColor: '#2B7C83' },
                                fontFamily: 'montserrat',
                                fontWeight: 'bold',
                            }}
                            variant="contained"
                            onClick={handleGuardarInfo}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 3, flexWrap: 'wrap' }}>
                {infoEstudiante.map((info, index) => (
                    <Box key={index} sx={{ display: 'inline-block', m: 1 }}>
                        <Button
                            variant="outlined"
                            onClick={() => handleEliminarInfo(index)}
                            sx={{
                                color: '#336B87',
                                fontFamily: 'Montserrat',
                                fontWeight: 'medium',
                                fontSize: '1.25rem',
                                borderColor: 'rgba(51, 107, 135, 0.3)',
                                borderRadius: 50,
                                backgroundColor: 'rgba(51, 107, 135, 0.3)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: '#FFF', borderColor: '#336B87' },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: 'montserrat',
                                    fontSize: '1.25rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#336B87',
                                    textTransform: 'none',
                                }}
                            >
                                {info}
                                <HighlightOffIcon sx={{ ml: 1, color: '#CD5C5C' }} />
                            </Typography>
                        </Button>
                    </Box>
                ))}
                <Button
                    variant="outlined"
                    sx={{
                        
                        fontFamily: 'Montserrat',
                        fontWeight: 'medium',
                        fontSize: '1.25rem',
                        borderColor: 'rgba(51, 107, 135, 0.3)',
                        borderStyle: 'dashed',
                        borderRadius: 50,
                        backgroundColor: '#FFF',
                        boxShadow: 3,
                        '&:hover': { backgroundColor: 'rgba(51, 107, 135, 0.3)', boxShadow: 6, borderColor: 'rgba(51, 107, 135, 0.3)', borderStyle: 'dashed' },
                        color: '#336B87',
                        textTransform: 'none',
                    }}
                    onClick={handleAgregarInfo}
                >
                    <img src={plusIcon} alt="Icono" style={{ width: '25px', height: '25px' }} />
                </Button>
            </Box>
            )}
        </Grid>
    );
};

export default ContextoEspecíficoEstudiante;
